import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  TextField,
  Grid,
  Avatar,
  IconButton,
  DialogActions,
  DialogContent,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@material-ui/core";
import serviciosTablero from "utils/serviciosTablero";
import { AvatarParticipante } from "views/Tablero/Components/Item";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";

const Avatars = ({
  tarjeta,
  dataTarjeta,
  infoTablero,
  miembros,
  setMiembros,
  setParticipantesTarjeta,
  setCargando,
  setMensaje,
  updateData
}) => {
  const classesTablero = useStylesTablero();
  const [avatars, setAvatars] = useState([]);
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const [miembrosDisponibles, setMiembrosDisponibles] = useState([]);
  const { register, errors, setValue, control, getValues } = useForm();
  const [open, setOpen] = useState(false);

  const getMiembrosDisponibles = () => {
    serviciosTablero.getMiembrosDisponiblesTarjeta(
      (data) => {
        setMiembrosDisponibles(
          data?.participantesDisponibles?.map((miembro) => miembro) || []
        );
      },
      setCargando,
      { idtarjeta: tarjeta, idtablero: infoTablero?.idtablero }
    );
  };

  const handleClickOpen = () => {
    getMiembrosDisponibles();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAvatar("");
  };

  const addAvatar = () => {
    if (selectedAvatar) {
      const selectedMember = miembrosDisponibles.find(
        (miembro) => miembro.idusuario === selectedAvatar
      );
      const newAvatar = {
        id: selectedMember.idusuario,
        nombre: selectedMember.nombre,
        idtarjeta: tarjeta,
        idestatus: 1,
      };
      serviciosTablero.agregarMiembroTarjeta(
        (status, mensaje, data) => {
          setMensaje({ open: true, status: status, value: mensaje });
          if (data.miembros) {
            setParticipantesTarjeta(data.miembros);
            setMiembros(data.miembros);

            let nuevaDataTarjeta = {
              ...dataTarjeta,
              participantes: data.miembros,
            };
            updateData("tarjeta", nuevaDataTarjeta, tarjeta);
          }
        },
        setCargando,
        newAvatar
      );
      handleClose();
    }
  };

  return (
    <div>
      <Typography variant="h6" marginBottom={2} style={{ color: "#CCCCCC" }}>
        Miembros
      </Typography>
      <Grid container spacing={1.5}>
        {/* Mapea los miembros para mostrarlos como AvatarParticipante */}
        {miembros.map((avatar, index) => (
          <Grid item key={index} style={{ marginBottom: "6px" }}>
            <AvatarParticipante
              infoColaborador={{
                nombre: avatar.nombre,
                correo: avatar.correo,
                color: avatar.color,
                avatar: avatar.avatar,
              }}
            />
          </Grid>
        ))}
        <Grid item>
          <IconButton onClick={handleClickOpen} style={{margin:0}}>
            <Avatar style={{ width: "32px", height: "32px" }}>+</Avatar>
          </IconButton>
        </Grid>
      </Grid>

      {/* Diálogo para seleccionar un avatar */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Añadir miembro</DialogTitle>
        <DialogContent>
          <Controller
            control={control}
            name="miembro"
            render={(props) => (
              <Autocomplete
                id="tags-solicitud"
                options={miembrosDisponibles || []}
                onChange={(event, item) => {
                  setValue("miembro", item?.idusuario || null);
                  setSelectedAvatar(item?.idusuario);
                }}
                getOptionLabel={(option) => option.nombre}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Seleccionar miembro"
                    name="miembroTxt"
                    helperText={errors?.solicitud?.message}
                    error={errors?.solicitud}
                    className={classesTablero.field}
                  />
                )}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className={classesTablero.btnCancelar}>
            Cancelar
          </Button>
          <Button onClick={addAvatar} className={classesTablero.btnAceptar}>
            Añadir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Avatars;
